import React, { useState } from "react";
import { LoadingOverlay, Stack, Title } from "@mantine/core";
import BusinessHoursForm from "./forms/BusinessHoursForm";
import { useSalon } from "../context/SalonContext";
import { useMediaQuery } from "@mantine/hooks";

function BusinessHoursPage({ onSubmit }) {
  const { businessInfo } = useSalon();
  const [isLoading, setIsLoading] = useState(false);
  const isMobile = useMediaQuery("(max-width: 768px)");
  const handleSubmit = async (hoursData) => {
    if (!hoursData) {
      onSubmit(null, true);
      return;
    }

    try {
      setIsLoading(true);
      onSubmit(hoursData, true);
    } catch (error) {
      console.error("Error updating business hours:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Stack>
      <LoadingOverlay visible={isLoading} overlayProps={{ blur: 2 }} />
      <Stack
        p={{ base: "0", sm: "md", md: "xl" }}
        w={isMobile ? "100%" : "90%"}
        maw="60rem"
        mx="auto"
        align="center"
      >
        <Title order={2} c="gray.8">
          Business Hours
        </Title>
        <BusinessHoursForm
          initialData={businessInfo}
          onSubmit={handleSubmit}
          includeSkip={true}
        />
      </Stack>
    </Stack>
  );
}

export default BusinessHoursPage;
